import React from 'react';
import TransportActions from '../actions/TransportActions';
import TransportStore from '../stores/TransportStore';
import AuthStore from '../stores/AuthStore';
import { Link } from 'react-router-dom';

function getTransportListItem(transport) {
  return (
    <tr key={transport.id}>
      <td>{transport.name}</td>
      <td>{transport.order_date.split(' ')[0]}</td>
      <td>{transport.transport_date.split(' ')[0]}</td>
      <td className="right narrow">{transport.provision.toFixed(2)} zł</td>
    </tr>
  )
}

class TransportsDetailComponent extends React.Component {

  constructor() {
    super();
    this.state = {
      month: {},
      pid: AuthStore.getUser().id
    }
    this.onChange = this.onChange.bind(this)
  }

  componentWillMount() {
    TransportStore.addChangeListener(this.onChange)
  }

  componentDidMount() {
    TransportActions.getTransports(this.state.pid, parseInt(this.props.match.params.year), parseInt(this.props.match.params.month))
  }

  componentWillUnmount() {
    TransportStore.removeChangeListener(this.onChange)
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      month: TransportActions.getTransports(this.state.pid, parseInt(nextProps.match.params.year), parseInt(nextProps.match.params.month))
    });
  }

  onChange() {
    this.setState({
      month: TransportStore.getTransports()
    });
  }

  render() {
    let month
    let sum = 0
    if (this.state.month) {
      month = this.state.month
      if (this.state.month.transports) {
        this.state.month.transports.map(transport => { sum += transport.provision })
      }
    }
    return (
      <div className="project-view">
        { this.state.month &&
          <div className="breadcrumb">
            <h1><Link to='/'>Miesiące</Link> &nbsp;&rsaquo;&nbsp; {this.state.month.name}</h1>
          </div>
        }
        { this.state.month && this.state.month.transports &&
          <table>
            <thead>
              <tr>
                <th>Nazwa</th>
                <th>Data zlecenia</th>
                <th>Data transportu</th>
                <th className="right narrow">Prowizja</th>
              </tr>
            </thead>
            <tbody>
              {month.transports && month.transports.map(transport => getTransportListItem(transport))}
            </tbody>
            <tfoot>
              <tr style={{'backgroundColor': 'transparent'}}>
                <td colSpan="3" className="right" style={{'borderColor': 'transparent'}}><strong>Razem:</strong></td>
                <th className="right narrow">{sum.toFixed(2)}&nbsp;zł</th>
              </tr>
            </tfoot>
          </table>
        }
      </div>
    )
  }
}

export default TransportsDetailComponent;



// WEBPACK FOOTER //
// ./src/components/Transports.js